import React from "react";
import MapPage from "./pages/MapPage";

function App() {
  return <MapPage />;
}

export default App;